import type { SelectedFacetV2 } from '../graphql/codegen';
import type { Maybe } from 'graphql/jsutils/Maybe';

export const solrFacetsToAlgoliaFacets = (selectedFacetsV2: Maybe<SelectedFacetV2>[]) => {
  const facets = selectedFacetsV2?.reduce((algoliaObject, facet) => {
    if (facet?.code) {
      const facetValue = facet?.facetValues?.map(facet => facet?.code).join(',');

      return {
        ...algoliaObject,
        ...{ [facet?.code]: facetValue },
      };
    }

    return algoliaObject;
  }, {} as { [key: string]: string | undefined });

  return facets;
};
